import { BASE_URL } from '~/service/constants'
import { apiSubscriptionQuickbooksCallbackPath } from '~/routes'

const headers = (jwt) => ({
  Accept: 'application/json',
  'Content-Type': 'application/json',
  Authorization: `Bearer ${jwt}`,
})

const handleApiError = async (response, defaultErrorMessage = '') => {
  let errorData
  try {
    errorData = await response.json()
  } catch {
    throw new Error(`${defaultErrorMessage} (HTTP ${response.status})`)
  }
  throw new Error(errorData?.errors?.[0] || errorData?.error || defaultErrorMessage)
}

export async function fetchQuickbooksCallbackUrl(companyId, subscriptionId, jwt) {
  const response = await fetch(
    `${BASE_URL}${apiSubscriptionQuickbooksCallbackPath(companyId, subscriptionId)}`,
    { headers: headers(jwt) }
  )
  if (!response.ok) await handleApiError(response, 'Failed to fetch the QuickBooks return URL')
  const data = await response.json()
  return data.url
}
